define(['./eTrackerAdapter'], (eTrackerAdapter) => {
    const configuration = {
    };

    const plugins = [];

    return {
        configure(config) {
            Object.assign(configuration, config);
            return this;
        },

        enablePlugin(pluginName) {
            plugins.push(pluginName);
            return this;
        },

        $get: [
            'eTracker',
            (ea) => {

                // Diego Cabero: If this eTrackerAdapterProvider is called, then we have to 
                // inject the following <script> to <head> section in index.html
                // <script id="_etLoader" type="text/javascript" charset="UTF-8" 
                // data-secure-code="26m0D3" src="//static.etracker.com/code/e.js"></script>
                window.et_pagename = '';
                window.et_areas = '';
                window.et_url = '';

                const js = document.createElement('script');
                js.id = '_etLoader';
                js.type = 'text/javascript';
                js.charset = 'UTF-8';
                js.setAttribute('data-secure-code', configuration.trackingID);
                js.src = configuration.url;
                document.head.appendChild(js);
                
                return eTrackerAdapter(ea, configuration, plugins);
            },
        ],
    };
});



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/tracking/adapters/eTrackerAdapterProvider.js